// ============================================================
// VCS.chatForward  Weiterleiten-Dialog fuer Chat-Nachrichten
// - Nur eigene Nachrichten (Sender == myPhone), nur 1:1-Chats als Ziel
// - Phase 1: plain->plain server-seitig via POST /messages/forward
// - Phase 2 (TODO): Client-Reupload fuer E2E-Ziele
// ============================================================
window.VCS = window.VCS || {};

(function () {
    'use strict';

    const t = (k, vars) => {
        const raw = VCS.i18n?.t?.(k) || k;
        if (!vars) return raw;
        return raw.replace(/\{(\w+)\}/g, (_, name) => (name in vars ? vars[name] : '{' + name + '}'));
    };
    const escapeHtml = VCS.helpers?.escapeHtml || ((s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c])));

    class ChatForward {

        constructor() {
            this._overlay = null;
            this._dialog = null;
            this._list = null;
            this._search = null;
            this._sendBtn = null;
            this._sourceMsg = null;
            this._selected = new Set();
            this._chats = [];
            this._inited = false;
            this._vvHandler = null;
            this._busy = false;
        }

        init() {
            if (this._inited) return;
            this._overlay = document.getElementById('chatForwardOverlay');
            this._dialog = this._overlay?.querySelector('.chat-forward-dialog') || null;
            this._list = document.getElementById('chatForwardList');
            this._search = document.getElementById('chatForwardSearch');
            this._sendBtn = document.getElementById('chatForwardSend');
            if (!this._overlay || !this._list || !this._search || !this._sendBtn) {
                console.warn('[chatForward] init: DOM-Elemente nicht gefunden');
                return;
            }

            document.getElementById('chatForwardClose')?.addEventListener('click', () => this.close());
            this._overlay.addEventListener('click', (e) => { if (e.target === this._overlay) this.close(); });
            this._search.addEventListener('input', () => this._renderList());
            this._sendBtn.addEventListener('click', () => this._submit());

            this._inited = true;
            console.log('[chatForward] initialisiert');
        }

        open(msg) {
            if (!this._inited) this.init();
            if (!msg) {
                console.warn('[chatForward] open: kein msg uebergeben');
                return;
            }
            this._sourceMsg = msg;
            this._selected.clear();

            const BOT_PHONE = VCS.Chat?.BOT_PHONE || '+493034359156';
            this._chats = (VCS.state.chatChats || [])
                .filter(c => !c.isGroup && !c._isGroup)
                .filter(c => c.id !== msg.chatId)
                .filter(c => {
                    const peer = VCS.chat?.peerPhone?.(c);
                    return peer && peer !== BOT_PHONE;
                });

            this._search.value = '';
            this._renderList();
            this._updateSendBtn();
            this._overlay.classList.remove('hidden');

            // Fokus auf den Senden-Button setzen, damit auf Mobile NICHT die Tastatur aufpoppt.
            setTimeout(() => this._sendBtn.focus(), 50);

            // VisualViewport-Listener: Dialog nachfuehren wenn Tastatur aufgeht
            this._attachViewportListener();
            console.log(`[chatForward] open: msgId=${msg.id} candidates=${this._chats.length}`);
        }

        close() {
            // Waehrend des Weiterleitens nicht schliessen - Upload laeuft noch
            if (this._busy) return;
            this._overlay?.classList.add('hidden');
            this._sourceMsg = null;
            this._selected.clear();
            this._detachViewportListener();
            this._resetDialogPosition();
        }

        _attachViewportListener() {
            if (!window.visualViewport || this._vvHandler) return;
            this._vvHandler = () => this._adjustForKeyboard();
            window.visualViewport.addEventListener('resize', this._vvHandler);
            window.visualViewport.addEventListener('scroll', this._vvHandler);
            // Initial einmal aufrufen falls Tastatur schon offen
            this._adjustForKeyboard();
        }

        _detachViewportListener() {
            if (!window.visualViewport || !this._vvHandler) return;
            window.visualViewport.removeEventListener('resize', this._vvHandler);
            window.visualViewport.removeEventListener('scroll', this._vvHandler);
            this._vvHandler = null;
        }

        _resetDialogPosition() {
            if (!this._dialog) return;
            this._dialog.style.transform = '';
            this._dialog.style.maxHeight = '';
        }

        _adjustForKeyboard() {
            if (!this._dialog || !window.visualViewport) return;
            const vv = window.visualViewport;
            const fullHeight = window.innerHeight;
            const visibleHeight = vv.height;
            const visibleTop = vv.offsetTop;
            // Tastatur verdeckt unten = fullHeight - visibleTop - visibleHeight
            const keyboardHeight = Math.max(0, fullHeight - visibleTop - visibleHeight);

            if (keyboardHeight > 50) {
                // Dialog max. so hoch wie sichtbarer Bereich (mit etwas Padding)
                this._dialog.style.maxHeight = (visibleHeight - 32) + 'px';
                // Overlay zentriert in fullHeight; sichtbare Mitte = visibleTop + visibleHeight/2
                // Verschiebung = sichtbare Mitte - fullHeight/2
                const shift = (visibleTop + visibleHeight / 2) - (fullHeight / 2);
                this._dialog.style.transform = `translateY(${shift}px)`;
            } else {
                this._resetDialogPosition();
            }
        }

        _renderList() {
            if (!this._list) return;
            const q = (this._search.value || '').trim().toLowerCase();

            const enriched = this._chats.map(c => {
                const peerPhone = VCS.chat?.peerPhone?.(c) || '';
                // Dating-Match: Nummer weder anzeigen noch als Namens-Fallback nutzen.
                const isMatch = !!c.isDatingMatch;
                const name = c._peerName || (isMatch ? t('datingContactMatch') : peerPhone);
                return { chat: c, peerPhone, name, isMatch };
            });

            // Uebersetzte Videos lassen sich nicht sauber in E2E-Chats weiterleiten
            // (verschluesseltes Uebersetzungs-Video wird beim Empfaenger kaputt dargestellt).
            // E2E-Ziele werden dann ausgegraut und sind nicht waehlbar.
            const srcMsg = this._sourceMsg;
            const isTranslatedVideo = !!srcMsg && srcMsg.mediaType === 'video'
                && !!(srcMsg.translatedVideoUrl || srcMsg.transcription);

            const filtered = enriched.filter(({ peerPhone, name, isMatch }) => {
                if (!q) return true;
                // Bei Matches nicht nach der Nummer suchen -- sonst liesse sie sich
                // ueber die Trefferliste stueckweise erraten.
                if (name.toLowerCase().includes(q)) return true;
                return !isMatch && peerPhone.toLowerCase().includes(q);
            });

            if (!filtered.length) {
                this._list.innerHTML = `<div class="chat-forward-empty">${escapeHtml(t('chatForwardEmpty'))}</div>`;
                return;
            }

            this._list.innerHTML = filtered.map(({ chat, peerPhone, name, isMatch }) => {
                const blocked = isTranslatedVideo && !!VCS.state.chatE2EEnabled[chat.id];
                const checked = (!blocked && this._selected.has(chat.id)) ? 'checked' : '';
                const initial = (name || '?').charAt(0).toUpperCase();
                const avatarHash = chat._peerAvatarHash || '';
                const avatarHtml = avatarHash
                    ? `<img src="${VCS.Chat.API_BASE}/profile/avatar/${escapeHtml(avatarHash)}" alt="" class="chat-forward-avatar-img">`
                    : escapeHtml(initial);
                const subLine = blocked ? t('chatForwardE2EBlocked') : (isMatch ? t('datingContactMatch') : peerPhone);
                return `
                    <label class="chat-forward-item${blocked ? ' chat-forward-item--disabled' : ''}" data-chat-id="${escapeHtml(chat.id)}">
                        <div class="chat-forward-avatar">${avatarHtml}</div>
                        <div class="chat-forward-info">
                            <div class="chat-forward-name">${escapeHtml(name)}</div>
                            <div class="chat-forward-phone">${escapeHtml(subLine)}</div>
                        </div>
                        <input type="checkbox" class="chat-forward-check" ${checked}${blocked ? ' disabled' : ''} data-chat-id="${escapeHtml(chat.id)}">
                    </label>
                `;
            }).join('');

            this._list.querySelectorAll('input.chat-forward-check').forEach(cb => {
                cb.addEventListener('change', (e) => {
                    const chatId = e.target.dataset.chatId;
                    if (e.target.checked) this._selected.add(chatId);
                    else this._selected.delete(chatId);
                    this._updateSendBtn();
                });
            });
        }

        // Fortschritt im Senden-Button anzeigen und Dialog sperren, solange
        // weitergeleitet wird. Videos in E2E-Chats brauchen dafuer mehrere Sekunden
        // (Download, Neu-Verschluesselung, Upload) - ohne Anzeige wirkt die App haengend.
        _setBusy(busy, progressText) {
            this._busy = busy;
            this._dialog?.classList.toggle('chat-forward-dialog--busy', busy);
            this._search.disabled = busy;
            this._list.querySelectorAll('input.chat-forward-check').forEach(cb => {
                if (busy) cb.dataset.wasDisabled = cb.disabled ? '1' : '';
                cb.disabled = busy || cb.dataset.wasDisabled === '1';
            });
            if (busy) {
                this._sendBtn.disabled = true;
                this._sendBtn.innerHTML = `<span class="chat-forward-send-spinner"></span>${escapeHtml(progressText || t('chatForwardSending'))}`;
            } else {
                this._updateSendBtn();
            }
        }

        _updateSendBtn() {
            if (!this._sendBtn) return;
            const n = this._selected.size;
            this._sendBtn.textContent = t('chatForwardButton', { n });
            this._sendBtn.disabled = n === 0;
        }

        async _submit() {
            const msg = this._sourceMsg;
            if (!msg || this._selected.size === 0) return;

            if (this._busy) return;
            const targetChatIds = [...this._selected];
            this._setBusy(true);
            console.log(`[chatForward] submit: msgId=${msg.id} targets=${targetChatIds.length}`);

            let okCount = 0;
            let skipped = 0;

            try {
                // 1) Serverseitiger Forward (plain->plain). E2E-Ziele kommen in requiresReupload.
                const res = await fetch(VCS.Chat.API_BASE + '/messages/forward', {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-phone': VCS.state.chatMyPhone || '',
                    },
                    body: JSON.stringify({ sourceMsgId: msg.id, targetChatIds }),
                });

                if (!res.ok) {
                    const errText = await res.text().catch(() => '');
                    console.error(`[chatForward] server-error status=${res.status} body=${errText}`);
                    VCS.ui?.showToast?.(`Forward failed (${res.status})`, 'error');
                    return;
                }

                const data = await res.json();
                okCount = Array.isArray(data.forwarded) ? data.forwarded.length : 0;
                const reupload = Array.isArray(data.requiresReupload) ? data.requiresReupload : [];
                console.log(`[chatForward] server-response: forwarded=${okCount} reupload=${reupload.length}`);

                // 2) Clientseitiger Reupload pro Ziel (E2E-Faelle)
                const isMedia = !!(msg.mediaUrl || msg.audioUrl);
                let reuploadIndex = 0;
                for (const item of reupload) {
                    reuploadIndex++;
                    if (reupload.length > 1) {
                        this._setBusy(true, `${t('chatForwardSending')} (${reuploadIndex}/${reupload.length})`);
                    }
                    if (item.reason !== 'e2e') {
                        skipped++;
                        console.warn(`[chatForward] skip chatId=${item.chatId} reason=${item.reason}`);
                        continue;
                    }
                    const isVoicephoto = msg.mediaType === 'voicephoto';
                    const isVoiceOnly = !!msg.audioUrl && !msg.mediaUrl;
                    const isMediaOnly = !!msg.mediaUrl && !isVoicephoto;

                    let handler;
                    if (isVoicephoto)      handler = this._reuploadVoicephoto.bind(this);
                    else if (isVoiceOnly)  handler = this._reuploadVoice.bind(this);
                    else if (isMediaOnly)  handler = this._reuploadMedia.bind(this);
                    else                   handler = this._reuploadText.bind(this);

                    try {
                        const ok = await handler(item.chatId, msg);
                        if (ok) okCount++; else skipped++;
                    } catch (err) {
                        console.error(`[chatForward] reupload error chatId=${item.chatId} type=${msg.mediaType || 'text'}:`, err);
                        skipped++;
                    }
                }

                console.log(`[chatForward] done: forwarded=${okCount} skipped=${skipped}`);

                if (okCount > 0) {
                    VCS.ui?.showToast?.(t('chatForwarded') + (okCount > 1 ? ` (${okCount})` : ''), 'success');
                }
                if (skipped > 0) {
                    VCS.ui?.showToast?.(`${skipped} ${t('chatForward').toLowerCase()} ${t('failed') || 'fehlgeschlagen'}`, 'info');
                }

                this._setBusy(false);
                this.close();
            } catch (err) {
                console.error('[chatForward] exception:', err);
                VCS.ui?.showToast?.(String(err.message || err), 'error');
            } finally {
                if (this._busy) this._setBusy(false);
            }
        }

        // Text-Nachricht clientseitig in einen Ziel-Chat senden.
        // Verschluesselt automatisch wenn der Zielchat E2E aktiv hat.
        // Hinweis: Bei E2E-Zielen gibt es serverseitig keine Translation-Spalte fuer den Geheimtext.
        // Loesung: Original + Uebersetzung werden mit Trennstrich zu EINEM Text zusammengefuegt
        // und gemeinsam verschluesselt — der Empfaenger sieht beide Sprachen in einer Nachricht.
        async _reuploadText(targetChatId, srcMsg) {
            const original = srcMsg._decryptedText || srcMsg.originalText || '';
            const translated = srcMsg.translatedText || '';
            let plainText = original;
            if (translated && translated.trim() && translated !== original) {
                plainText = original + '\n\n---------------------\n\n' + translated;
            }
            if (!plainText.trim()) {
                console.warn(`[chatForward] reuploadText: leerer Text msgId=${srcMsg.id}`);
                return false;
            }

            const targetE2E = !!VCS.state.chatE2EEnabled[targetChatId];
            let sendText = plainText;
            let encrypted = false;
            let iv = null;
            let keyVersion = 1;
            let recipientKeyVersion = 1;

            if (targetE2E && typeof E2E !== 'undefined') {
                const sharedKey = await VCS.e2e?.getOrDeriveKey?.(targetChatId);
                if (!sharedKey) {
                    console.warn(`[chatForward] reuploadText: kein E2E-Key fuer chatId=${targetChatId}`);
                    return false;
                }
                const enc = await E2E.encryptText(sharedKey, plainText);
                sendText = enc.ciphertext;
                iv = enc.iv;
                encrypted = true;
                if (sharedKey._versionInfo) {
                    keyVersion = sharedKey._versionInfo.senderVersion;
                    recipientKeyVersion = sharedKey._versionInfo.recipientVersion;
                }
            }

            console.log(`[chatForward] reuploadText: chatId=${targetChatId} e2e=${targetE2E} len=${plainText.length}`);

            const res = await fetch(VCS.Chat.API_BASE + '/messages', {
                method: 'POST',
                headers: VCS.chat?.authHeaders({'Content-Type': 'application/json'}),
                body: JSON.stringify({
                    chatId: targetChatId,
                    text: sendText,
                    senderLang: srcMsg.senderLang || VCS.state.currentLang,
                    translate: false,
                    encrypted,
                    iv,
                    keyVersion,
                    recipientKeyVersion,
                    isForwarded: true
                })
            });

            if (!res.ok) {
                const errText = await res.text().catch(() => '');
                console.error(`[chatForward] reuploadText server-error chatId=${targetChatId} status=${res.status} body=${errText}`);
                return false;
            }
            return true;
        }

        // ───────── Helper für Media-Reupload ─────────

        // Quell-Chat-Key holen (für Decrypt)
        async _resolveSourceKey(srcMsg) {
            const sv = srcMsg.keyVersion || 1;
            const rv = srcMsg.recipientKeyVersion || 1;
            const versionInfo = (sv > 1 || rv > 1)
                ? { senderVersion: sv, recipientVersion: rv, senderPhone: srcMsg.senderPhone }
                : null;
            return VCS.e2e?.getOrDeriveKey?.(srcMsg.chatId, versionInfo);
        }

        // Datei laden + ggf. mit srcKey/iv entschluesseln. Liefert Klartext-Blob oder null.
        async _fetchAndDecrypt(url, iv, srcMsg, mime) {
            const resp = await fetch(url);
            if (!resp.ok) {
                console.error(`[chatForward] download failed url=${url} status=${resp.status}`);
                return null;
            }
            let blob = await resp.blob();
            if (iv) {
                if (typeof E2E === 'undefined') return null;
                const srcKey = await this._resolveSourceKey(srcMsg);
                if (!srcKey) {
                    console.warn(`[chatForward] kein Quell-Key chatId=${srcMsg.chatId}`);
                    return null;
                }
                const dec = await E2E.decryptBlob(srcKey, blob, iv, mime);
                if (!dec) {
                    console.error(`[chatForward] decrypt failed url=${url}`);
                    return null;
                }
                blob = dec;
            }
            return blob;
        }

        // Verschluesselt Klartext-Blob fuer Ziel-Key. Liefert {file, iv, keyVersion, recipientKeyVersion}.
        // File (statt Blob) mit Filename, exakt wie chat-media.js#uploadMedia — Busboy-kompatibel auch bei groesseren Dateien.
        async _encryptForTarget(blob, targetKey, filename) {
            const enc = await E2E.encryptBlob(targetKey, blob);
            return {
                file: new File([enc.encryptedBlob], filename || 'file', { type: 'application/octet-stream' }),
                iv: enc.iv,
                keyVersion: targetKey._versionInfo?.senderVersion || 1,
                recipientKeyVersion: targetKey._versionInfo?.recipientVersion || 1,
            };
        }

        // Caption-Text fuer Ziel vorbereiten: bei E2E-Ziel verschluesselt-JSON, sonst plain.
        async _prepareCaption(plainText, targetKey) {
            if (!plainText) return '';
            if (!targetKey) return plainText;
            const encText = await E2E.encryptText(targetKey, plainText);
            return JSON.stringify({ ct: encText.ciphertext, iv: encText.iv });
        }

        // Mime-Lookup nach mediaType
        _mimeFor(mediaType, isAudio) {
            if (isAudio) return 'audio/mp4';
            if (mediaType === 'image') return 'image/jpeg';
            if (mediaType === 'video') return 'video/mp4';
            if (mediaType === 'music') return 'audio/mpeg';
            if (mediaType === 'document') return 'application/pdf';
            return 'application/octet-stream';
        }

        // ───────── Reupload-Methoden pro Typ ─────────

        // Bild / Video / Music — inkl. translatedVideoUrl wenn vorhanden
        async _reuploadMedia(targetChatId, srcMsg) {
            const targetE2E = !!VCS.state.chatE2EEnabled[targetChatId];
            const targetKey = targetE2E ? await VCS.e2e?.getOrDeriveKey?.(targetChatId) : null;
            if (targetE2E && !targetKey) {
                console.warn(`[chatForward] reuploadMedia: kein Ziel-Key chatId=${targetChatId}`);
                return false;
            }

            // Hauptdatei
            const mainMime = this._mimeFor(srcMsg.mediaType, false);
            const mainBlob = await this._fetchAndDecrypt(srcMsg.mediaUrl, srcMsg.encrypted ? srcMsg.iv : null, srcMsg, mainMime);
            if (!mainBlob) return false;

            // Optional: translated Video (nur bei Video)
            let translatedVideoBlob = null;
            if (srcMsg.mediaType === 'video' && srcMsg.translatedVideoUrl) {
                translatedVideoBlob = await this._fetchAndDecrypt(
                    srcMsg.translatedVideoUrl,
                    srcMsg.translatedVideoIv || null,
                    srcMsg,
                    'video/mp4'
                );
                if (!translatedVideoBlob) {
                    console.warn(`[chatForward] reuploadMedia: translatedVideo download/decrypt failed — ohne weitergeleitet`);
                }
            }

            // Verschluesseln fuer Ziel
            const caption = (srcMsg._decryptedText || srcMsg.originalText || '');
            let uploadMain = mainBlob;
            let uploadFilename = srcMsg.mediaFileName || 'file';
            let mainIv = null, keyVer = 1, recKeyVer = 1, encrypted = false;
            let sendCaption = caption;
            let translatedUpload = translatedVideoBlob;
            let translatedIv = null;

            if (targetE2E) {
                const enc = await this._encryptForTarget(mainBlob, targetKey, uploadFilename);
                uploadMain = enc.file; mainIv = enc.iv; keyVer = enc.keyVersion; recKeyVer = enc.recipientKeyVersion;
                encrypted = true;
                sendCaption = await this._prepareCaption(caption, targetKey);
                if (translatedVideoBlob) {
                    const encT = await this._encryptForTarget(translatedVideoBlob, targetKey, 'translated.mp4');
                    translatedUpload = encT.file; translatedIv = encT.iv;
                }
            }

            console.log(`[chatForward] reuploadMedia: chatId=${targetChatId} type=${srcMsg.mediaType} targetE2E=${targetE2E} hasTranslatedVideo=${!!translatedVideoBlob}`);

            const formData = new FormData();
            formData.append('chatId', targetChatId);
            formData.append('senderLang', srcMsg.senderLang || VCS.state.currentLang);
            formData.append('translate', 'false');
            formData.append('isForwarded', 'true');
            formData.append('media', uploadMain, uploadFilename);
            formData.append('caption', sendCaption || '');
            if (encrypted) {
                formData.append('encrypted', 'true');
                formData.append('iv', mainIv);
                formData.append('keyVersion', String(keyVer));
                formData.append('recipientKeyVersion', String(recKeyVer));
            }
            // Translation-Felder 1:1 uebernehmen
            if (srcMsg.translatedText) formData.append('translatedText', srcMsg.translatedText);
            // transcription bei Video = JSON mit Karaoke-Wort-Timestamps {original, translated, targetLang}
            if (srcMsg.transcription) formData.append('transcription', srcMsg.transcription);
            if (translatedUpload) {
                formData.append('translatedVideo', translatedUpload, 'translated.mp4');
                if (translatedIv) formData.append('translatedVideoIv', translatedIv);
                if (srcMsg.translatedVideoLang) formData.append('translatedVideoLang', srcMsg.translatedVideoLang);
                formData.append('translatedVideoStatus', srcMsg.translatedVideoStatus || 'ready');
            }

            const res = await fetch(VCS.Chat.API_BASE + '/messages/media', {
                method: 'POST', headers: VCS.chat?.authHeaders(), body: formData,
            });
            if (!res.ok) {
                const errText = await res.text().catch(() => '');
                console.error(`[chatForward] reuploadMedia server-error chatId=${targetChatId} status=${res.status} body=${errText}`);
                return false;
            }
            return true;
        }

        // Sprachnachricht (audioUrl, kein mediaUrl) — inkl. translatedAudioUrl + transcription + translatedText
        async _reuploadVoice(targetChatId, srcMsg) {
            const targetE2E = !!VCS.state.chatE2EEnabled[targetChatId];
            const targetKey = targetE2E ? await VCS.e2e?.getOrDeriveKey?.(targetChatId) : null;
            if (targetE2E && !targetKey) {
                console.warn(`[chatForward] reuploadVoice: kein Ziel-Key chatId=${targetChatId}`);
                return false;
            }

            const audioBlob = await this._fetchAndDecrypt(srcMsg.audioUrl, srcMsg.encrypted ? srcMsg.iv : null, srcMsg, 'audio/mp4');
            if (!audioBlob) return false;

            let translatedAudioBlob = null;
            if (srcMsg.translatedAudioUrl) {
                translatedAudioBlob = await this._fetchAndDecrypt(
                    srcMsg.translatedAudioUrl,
                    srcMsg.translatedAudioIv || null,
                    srcMsg,
                    'audio/mp4'
                );
                if (!translatedAudioBlob) {
                    console.warn(`[chatForward] reuploadVoice: translatedAudio download/decrypt failed — ohne weitergeleitet`);
                }
            }

            let uploadAudio = audioBlob;
            let audioIv = null, keyVer = 1, recKeyVer = 1, encrypted = false;
            let translatedUpload = translatedAudioBlob;
            let translatedIv = null;

            if (targetE2E) {
                const enc = await this._encryptForTarget(audioBlob, targetKey, 'voice.m4a');
                uploadAudio = enc.file; audioIv = enc.iv; keyVer = enc.keyVersion; recKeyVer = enc.recipientKeyVersion;
                encrypted = true;
                if (translatedAudioBlob) {
                    const encT = await this._encryptForTarget(translatedAudioBlob, targetKey, 'voice_translated.m4a');
                    translatedUpload = encT.file; translatedIv = encT.iv;
                }
            }

            console.log(`[chatForward] reuploadVoice: chatId=${targetChatId} targetE2E=${targetE2E} hasTranslatedAudio=${!!translatedAudioBlob}`);

            const formData = new FormData();
            formData.append('chatId', targetChatId);
            formData.append('senderLang', srcMsg.senderLang || VCS.state.currentLang);
            formData.append('durationMs', String(srcMsg.audioDurationMs || 0));
            formData.append('translate', 'false');
            formData.append('isForwarded', 'true');
            formData.append('audio', uploadAudio, 'voice.m4a');
            if (encrypted) {
                formData.append('encrypted', 'true');
                formData.append('iv', audioIv);
                formData.append('keyVersion', String(keyVer));
                formData.append('recipientKeyVersion', String(recKeyVer));
            }
            if (srcMsg.transcription) formData.append('transcription', srcMsg.transcription);
            if (srcMsg.translatedText) formData.append('translatedText', srcMsg.translatedText);
            if (translatedUpload) {
                formData.append('translatedAudio', translatedUpload, 'voice_translated.m4a');
                if (translatedIv) formData.append('translatedAudioIv', translatedIv);
                if (srcMsg.translatedAudioDurationMs) formData.append('translatedAudioDurationMs', String(srcMsg.translatedAudioDurationMs));
            }

            const res = await fetch(VCS.Chat.API_BASE + '/messages/voice', {
                method: 'POST', headers: VCS.chat?.authHeaders(), body: formData,
            });
            if (!res.ok) {
                const errText = await res.text().catch(() => '');
                console.error(`[chatForward] reuploadVoice server-error chatId=${targetChatId} status=${res.status} body=${errText}`);
                return false;
            }
            return true;
        }

        // Sprachbild (Foto + Audio + Caption + ggf. Translation)
        async _reuploadVoicephoto(targetChatId, srcMsg) {
            const targetE2E = !!VCS.state.chatE2EEnabled[targetChatId];
            const targetKey = targetE2E ? await VCS.e2e?.getOrDeriveKey?.(targetChatId) : null;
            if (targetE2E && !targetKey) {
                console.warn(`[chatForward] reuploadVoicephoto: kein Ziel-Key chatId=${targetChatId}`);
                return false;
            }

            // Foto laden (mediaUrl) — kann verschluesselt sein wenn Quelle E2E
            const photoBlob = await this._fetchAndDecrypt(srcMsg.mediaUrl, srcMsg.encrypted ? srcMsg.iv : null, srcMsg, 'image/jpeg');
            if (!photoBlob) return false;

            // Audio laden — voicephoto-Audio nutzt denselben msg.iv wie das Foto (ein gemeinsamer iv im Insert)
            // Also bei E2E-Quelle ist auch das Audio mit msg.iv zu entschluesseln.
            let audioBlob = null;
            if (srcMsg.audioUrl) {
                audioBlob = await this._fetchAndDecrypt(srcMsg.audioUrl, srcMsg.encrypted ? srcMsg.iv : null, srcMsg, 'audio/mp4');
                if (!audioBlob) return false;
            }

            // Translation-Audio (eigener iv: translatedAudioIv)
            let translatedAudioBlob = null;
            if (srcMsg.translatedAudioUrl) {
                translatedAudioBlob = await this._fetchAndDecrypt(
                    srcMsg.translatedAudioUrl,
                    srcMsg.translatedAudioIv || null,
                    srcMsg,
                    'audio/mp4'
                );
                if (!translatedAudioBlob) {
                    console.warn(`[chatForward] reuploadVoicephoto: translatedAudio download/decrypt failed — ohne weitergeleitet`);
                }
            }

            const caption = (srcMsg._decryptedText || srcMsg.originalText || '');

            let uploadPhoto = photoBlob, uploadAudio = audioBlob, sendCaption = caption;
            let mainIv = null, keyVer = 1, recKeyVer = 1, encrypted = false;
            let translatedUpload = translatedAudioBlob, translatedIv = null;

            if (targetE2E) {
                // Foto verschluesseln — bestimmt den Haupt-iv der Nachricht
                const encPhoto = await this._encryptForTarget(photoBlob, targetKey, srcMsg.mediaFileName || 'photo.jpg');
                uploadPhoto = encPhoto.file; mainIv = encPhoto.iv;
                keyVer = encPhoto.keyVersion; recKeyVer = encPhoto.recipientKeyVersion;
                encrypted = true;
                // Audio mit DEMSELBEN iv? Nein — in Voicephoto wird im Insert nur EIN iv gespeichert.
                // Der Server-Insert nimmt encrypted+iv aber nutzt sie pauschal. Praktisch: Audio mit gleichem iv ist nicht sicher (IV-Reuse), daher nutzen wir Voicephoto-E2E hier vorsichtig: Audio-Datei wird zwar verschluesselt, aber mit eigenem iv → das passt nicht ins aktuelle Schema. Solange der Server nur EIN iv pro Voicephoto speichert, geht E2E-Voicephoto in dieser Iteration NICHT sauber. Wir senden Foto verschluesselt + Audio plain (Server speichert msg.iv vom Foto, Audio bleibt unverschluesselt). User wurde informiert.
                if (audioBlob) {
                    // Pragmatisch: Audio bleibt unverschluesselt im voicephoto-Forward (bis Schema getrennte iv-Felder hat)
                    // Audio-Blob wird wie ein normaler audio-File hochgeladen.
                    uploadAudio = audioBlob;
                }
                sendCaption = await this._prepareCaption(caption, targetKey);
                if (translatedAudioBlob) {
                    const encT = await this._encryptForTarget(translatedAudioBlob, targetKey, 'voice_translated.m4a');
                    translatedUpload = encT.file; translatedIv = encT.iv;
                }
            }

            console.log(`[chatForward] reuploadVoicephoto: chatId=${targetChatId} targetE2E=${targetE2E} hasAudio=${!!audioBlob} hasTranslatedAudio=${!!translatedAudioBlob}`);

            const formData = new FormData();
            formData.append('chatId', targetChatId);
            formData.append('senderLang', srcMsg.senderLang || VCS.state.currentLang);
            formData.append('caption', sendCaption || '');
            formData.append('durationMs', String(srcMsg.audioDurationMs || 0));
            formData.append('translate', 'false');
            formData.append('isForwarded', 'true');
            formData.append('photo', uploadPhoto, srcMsg.mediaFileName || 'photo.jpg');
            if (uploadAudio) formData.append('audio', uploadAudio, 'voice.m4a');
            if (encrypted) {
                formData.append('encrypted', 'true');
                formData.append('iv', mainIv);
                formData.append('keyVersion', String(keyVer));
                formData.append('recipientKeyVersion', String(recKeyVer));
            }
            if (srcMsg.transcription) formData.append('transcription', srcMsg.transcription);
            if (srcMsg.translatedText) formData.append('translatedText', srcMsg.translatedText);
            if (translatedUpload) {
                formData.append('translatedAudio', translatedUpload, 'voice_translated.m4a');
                if (translatedIv) formData.append('translatedAudioIv', translatedIv);
                if (srcMsg.translatedAudioDurationMs) formData.append('translatedAudioDurationMs', String(srcMsg.translatedAudioDurationMs));
            }

            const res = await fetch(VCS.Chat.API_BASE + '/messages/voicephoto', {
                method: 'POST', headers: VCS.chat?.authHeaders(), body: formData,
            });
            if (!res.ok) {
                const errText = await res.text().catch(() => '');
                console.error(`[chatForward] reuploadVoicephoto server-error chatId=${targetChatId} status=${res.status} body=${errText}`);
                return false;
            }
            return true;
        }

    }

    VCS.chatForward = new ChatForward();
    $(document).ready(() => VCS.chatForward.init());

})();
